import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {CommandsService} from '@app/app/shared/services/commands.service';
import * as moment from 'moment-timezone';

@Component({
  templateUrl: './park-clock-form.html',
  selector: 'park-clock-form',
  styles: [`
    button.btn-site {
      background-color: #1365b6;
      color: white;
      border-radius: 4px;
    }

    button.btn-site:disabled {
      background-color: #bdbdbd;
    }
  `]
})

export class ParkClockFormComponent implements OnInit {
  @Input() public parkId: string;
  @Input() public id: string;
  @Input() timezone: string;
  @Output() getSearchStatusChange = new EventEmitter<boolean>();
  @Input() getSearchStatus: boolean;
  time: string;

  timeForm: FormGroup;
  inProgress = false;

  constructor(private comm: CommandsService) {
    this.timeForm = new FormGroup({
      day: new FormControl({year: 2020, month: 1, day: 1}, [Validators.required]),
      time: new FormControl({hour: 12, minute: 0, second: 0}, [Validators.required]),
    });
  }

  ngOnInit() {
    const m = moment.tz(new Date(), this.timezone);

    this.timeForm.patchValue({
      day: {
        year: m.year(),
        month: m.month() + 1,
        day: m.date(),
      },
      time: {
        hour: m.hour(),
        minute: m.minute(),
        second: m.second(),
      },
    });
  }

  onSubmit({value, valid}) {
    if (valid) {
      const day = moment(`${value.day.year}-${value.day.month}-${value.day.day}`, 'YYYY-MM-DD').format('YYYY-MM-DD');
      const time = moment(`${value.time.hour}:${value.time.minute}:${value.time.second}`, 'HH:mm:ss').format('HH:mm:ss');

      const dateTime = moment.tz(`${day} ${time}`, this.timezone);

      this.inProgress = true;

      this.comm.updateTime(this.parkId, this.id, dateTime.valueOf()).then((res) => {
        this.inProgress = false;
        this.setEditMode();
      }).catch((err) => {
        this.inProgress = false;
        alert(err);
      });
    }
  }

  public setEditMode() {
    this.getSearchStatusChange.emit(false);
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/forms/park-clock/park-clock-form.component.ts